// extracted by mini-css-extract-plugin
export default {"commonRoundedButtonLink":"QzxRd","commonRoundedButton":"nwkdR","buttonSecondary":"JXO8n nwkdR","buttonLink":"kiMJI QzxRd JXO8n nwkdR"};